<template>
	<contentBox v-bind:loading="!isLoaded" mainId="unlock" v-bind:noMt="true">
		<contentTitle v-if="isLoaded" v-bind:label="parcelUnlock? 'UNLOCK PARCEL': 'PURCHASE PLAN'" v-bind:labelClass="(parcelUnlock)?'':'text-white'" close="back" v-bind:noScroll="true" v-bind:noSticky="true">
			<h2 v-if="parcelUnlock" class="text-white font-weight-light pb-2">{{title}}</h2>
		</contentTitle>
		<contentBody v-if="isLoaded">
			
			<div class="plan-selection sticky-top shadow-dk">
				<div class="row">
					<div v-if="parcelUnlock" v-on:click="planSelect('parcelUnlock')" class="col plan-option" 
						v-bind:class="{'active':planSelected === 'parcelUnlock'}">
						<p>ONE OFF</p>
						<h4>$9</h4>
					</div>
					<div v-on:click="planSelect('dayPass')" class="col plan-option" 
						v-bind:class="{'active':planSelected === 'dayPass'}">
						<p>DAY PASS <span class="badge badge-dark" v-if="isPlanCurrent('dayPass')">ACTIVE</span></p>
						<h4>$24</h4>
					</div>
					<div v-on:click="planSelect('studio')" class="col plan-option"
						v-bind:class="{'active':planSelected === 'studio'}">
						
						<p>STUDIO <span class="badge badge-dark" v-if="isPlanCurrent('studio')">ACTIVE</span></p>
						<h4>$99/mo</h4>
					</div>
				</div>
				<div class="plan-selected" v-if="isPlanCurrent('studio')">
					<div class="px-3 py-2 text-left pb-1">
						<p class="mb-0" v-if="planSelected === 'parcelUnlock'">
							You already have a studio subscription. This parcel is unlocked.
						</p>
						<p class="mb-0" v-if="planSelected === 'dayPass'">
							You already have a studio subscription. No need for a day pass.
						</p>
						<p class="mb-0" v-if="planSelected === 'studio'">
							You are currently on this plan.
						</p>
					</div>

				</div>
				<div class="plan-selected" v-else-if="isPlanCurrent('dayPass')">
					<div class="px-3 py-2 text-left pb-1">
						<p class="mb-0" v-if="planSelected === 'parcelUnlock'">
							You already have a day pass. This parcel is unlocked.
						</p>
						<p class="mb-0" v-if="planSelected === 'dayPass'">
							You are currently on this plan.
						</p>
						<p class="mb-0" v-if="planSelected === 'studio'">
							Upgrade and get unlimited access to all Scoutred data.
						</p>
					</div>
					<div v-if="planSelected === 'studio'" class="text-left text-dark px-3 pb-3 bg-white">
						<purchase :parcel="parcel" :plan="plans[planSelected]"></purchase>
					</div>
				</div>
				<div v-else class="plan-selected">
					<div class="px-3 pt-2 text-left pb-1">
						<p class="mb-0" v-if="planSelected === 'parcelUnlock'">
							Access data, features and reports on this parcel.
						</p>
						<p class="mb-0" v-if="planSelected === 'dayPass'">
							Access to all Scoutred data for <strong>24 hours</strong>.
						</p>
						<p class="mb-0" v-if="planSelected === 'studio'">
							Unlimited access to all Scoutred data.
						</p>
					</div>
					<div class="text-left text-dark px-3 pb-3 bg-white">
						<purchase :parcel="parcel" :plan="plans[planSelected]"></purchase>
					</div>
				</div>
			</div>

			<div class="p-3">
				<h4 class="text-center pt-3">SIMPLIFY DUE DILIGENCE</h4>
				<p class="mt-0 mb-2">
					Purchase a plan above to get access to premium Scoutred data and downloads:
				</p>
				<ul class="mb-2 pl-1">
					<li><i class="material-icons md-18 mt-radio">check</i> Owner information</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Permit data</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Zoning and Overlays</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Client-ready PDF download</li>
					<li><i class="material-icons md-18 mt-radio">check</i> AutoCAD DXF download</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Parcel Dimensions <span class="badge badge-dark">NEW</span></li>
				</ul>
				<h5 class="mb-2">DAY AND STUDIO PASSES ONLY</h5>
				<ul class="m-0 pl-1">
					<li><i class="material-icons md-18 mt-radio">check</i> Access to all parcels</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Water and sewer line data</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Bulk CSV data exports</li>
				</ul>
			</div>

			<div class="px-3 pb-3 pt-0">
				<h4 class="text-center pt-3">ENTERPRISE &amp; GOVERNMENT</h4>
				<p class="mt-2 mb-2">
					Are you an Enterprise or Government that needs access to:
				</p>
				<ul class="mb-4 pl-1">
					<li><i class="material-icons md-18 mt-radio">check</i> Custom queries</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Filtered permit searches and trend analysis</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Scoutred's data via API</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Custom mapping Vector Tiles</li>
					<li><i class="material-icons md-18 mt-radio">check</i> User management and unified billing</li>
					<li><i class="material-icons md-18 mt-radio">check</i> Something else?</li>
				</ul>
				<p class="mb-0">
					We enjoy tackling large scale geospatial data problems and would love to talk. Give us a call at <a href="tel:619-866-4543">619-866-4543</a> or send an email to <a href="mailto:hello@scoutred.com">hello@scoutred.com</a>.
				</p>
			</div>

				<div class="px-3 pb-5">

					
					<div class="my-3 border-bottom-gray">&ensp;</div>

					<h4 class="text-center mt-5">WHAT PEOPLE ARE SAYING</h4>

					<blockquote class="blockquote mx-4 mt-5">
						<div class="mb-3">
							<img class="rounded-circle mx-auto d-block" style="width:80px;height:80px" src="../../assets/img/pedro.png"/>
						</div>
						<p class="my-2">"Your database is amazing and saves several steps in the process I usually use to get info about a property. I’m actually in a state of disbelief at how thorough the information is."</p>
						<footer class="blockquote-footer">Pedro Tavres <cite title="Source Title">R&S Tavares Associates, Inc.</cite></footer>
					</blockquote>

					<blockquote class="blockquote mx-3 mt-5">
						<div class="mb-3">
							<img class="rounded-circle mx-auto d-block" style="width:80px;height:80px" src="../../assets/img/kim.png"/>
						</div>
						<p class="my-2">"I love Scoutred. I was searching for parcel numbers and owner mailing addresses, and I was very happy to easily find exactly what I needed."</p>
						<footer class="blockquote-footer">Kimberly Rotter <cite title="Source Title">An Army of Writers</cite></footer>
					</blockquote>
				
					<div class="my-3 border-bottom-gray">&ensp;</div>

					<h4 class="text-center mt-5">FAQ</h4>

					<div class="font-weight-bold mt-4">
						Does the monthly subscription require a contract?
					</div>
					<p class="mt-2">
						Absolutely not. We pride ourselves on making your life easier. If you want to change your plan you can do so anytime from your user preferences.
					</p>

					<div class="font-weight-bold">
						How often is the data on Scoutred updated?
					</div>
					<p class="mt-2">
						Different data sets update at different intervals. The most dynamic data set is parcel ownership and is updated monthly. The rest of the datasets (i.e. zoning, overlays, etc.) are updated as new versions are released, usually quarterly or annually.
					</p>

					<div class="font-weight-bold">
						What geographic area does Scoutred cover?
					</div>
					<p class="mt-2">
						Currently Scoutred covers San Diego County and Los Angeles County and the majority of cities within those counties. We're planning on adding additional counties in the near future. Have a county you would like to see added? <a href="mailto:hello@scoutred.com?subject=County data request">Let us know!</a>
					</p>

					<div class="font-weight-bold">
						What if I have more questions?
					</div>
					<p class="mt-2">
						We'd love to have a chat! You can <a href="mailto:hello@scoutred.com?subject=I need help with Scoutred">email us</a>, anytime with any questions, comments or feedback you have.
					</p>
				</div>
		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';

import loader from '../loader';
import purchase from './unlock-purchase';

const planIds = {
	dayPass: 'plan_2',
	studio: 'plan_1',
}

const dayTs = 24*60*60*1000; 

export default {
	name: 'unlock',

	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		purchase
	},

	props: {
	},

	computed:{
		parcelUnlock:function(){
			return (this.$route.params.parcelId)? true: false;
		},
		parcel: function() {
			return this.$store.state.parcel.rec;
		},
		title:function(){

			let str = '';

			if (this.parcel){
				if (this.parcel.address && this.parcel.address.street && this.parcel.address.street.name){
					if (this.parcel.address.street.number !== null) str += this.parcel.address.street.number+' ';
					if (this.parcel.address.street.name !== null) str += this.parcel.address.street.name+' ';
					if (this.parcel.address.street.suffix !== null) str += this.parcel.address.street.suffix;
					if (this.parcel.address.unit !== null) str += ' #'+this.parcel.address.unit;
				} else {
					str = this.parcel.apnFmt;
				}
			}
			
			return str;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		plans:function(){
			return this.$store.state.plan.plans;
		},
		mapZoom: function(){
			return this.$store.state.map.params.zoom;
		},
		mapLoaded:function(){
			return this.$store.state.map.loaded;
		},
		mapBounds:function(){
			return this.$store.state.map.bounds;
		},
		planActive:function(){
			return this.$store.state.plan.active;
		},
		planCurrent:function(){
			return this.$store.state.plan.current;
		},
		planStatus:function(){
			if (this.planCurrent.plan.id === 'plan_1') return 'active';
			if (this.planCurrent.plan.id === 'plan_3') return 'active';
			let currentPlanTs = new Date(this.planCurrent.created).getTime();
			let left = (currentPlanTs + dayTs) - new Date().getTime();
			if (left > 0) return 'active';
			else return 'expired';
		}
	},
	created: function(){
		if (this.$route.query.addressId) this.$data.addressId = this.$route.query.addressId;

		this.getDimensions();

		// check if user already is in a plan, if so redirect user to parcel or home
		if ((this.planCurrent && this.planStatus === 'active') || (this.parcelUnlock && this.parcel && this.parcel.unlocked)){
			if (this.parcelUnlock && this.parcel){
				this.$router.replace({
					name: 'parcels', 
					params:{
						id: this.parcel.id
					},
					query:{
						addressId: this.$data.addressId
					}
				});
				return;
			}
		}

		if (this.$router.currentRoute.query.plan){
			this.$data.planSelected = this.$router.currentRoute.query.plan;
			return;
		}
		if (this.parcelUnlock){
			this.getParcelRec();
			this.$data.planSelected = 'parcelUnlock';
			return;
		} else {
			this.isLoaded = true;
		}
		this.$data.planSelected = 'dayPass';
	},
	data: function(){
		return {
			email: null,
			isLoaded:false,
			password: null,
			planSelected:null,
			card:null,
			formSubmitted:null,
			loading:false,
			addressId:null
		}
	},
   methods: {
   	isPlanCurrent: function(planName){
   		return this.planCurrent && this.planCurrent.plan && this.planCurrent.plan.id === planIds[planName]
   	},
   	getDimensions: function(){
   		if (!this.$route.params.parcelId) return
			this.$store.dispatch('PARCEL_GET_DIMENSIONS', {
				id: this.$route.params.parcelId,
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
    getParcelRec:function(){
    	this.$store.dispatch('PARCEL_GET', {
				id: this.$route.params.parcelId,
				addressId: this.$data.addressId
			});
    },

		routeBack:function(){
			this.$router.go(-1);
		},
		planSelect(pack){
			this.$data.planSelected = pack;
		},

		parcelHighlight: function(){
			this.$store.dispatch('PARCEL_HIGHLIGHT', {});
		},
		parcelZoomTo: function(){
			this.$store.dispatch('PARCEL_ZOOM_TO', {});
			this.$store.dispatch('PARCEL_HIGHLIGHT', {});
		},
		parcelCheckInside:function(){
			const bbox = this.parcel.bounds.bbox;
			const bounds = this.mapBounds;

			if (this.mapZoom >= 22 || this.mapZoom <= 12) return false;
			if (bbox[1] > bounds._ne.lat || bbox[3] < bounds._sw.lat || 
				bbox[0] > bounds._ne.lng || bbox[2] < bounds._sw.lng){
				return false;
			}

			return true;
		},
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (this.parcelUnlock && !this.parcel) return;
			if (!this.mapLoaded) return;
			this.ready();
		},
		ready:function(){
			if (this.parcel){
				if (!this.parcelCheckInside()) this.parcelZoomTo();
				else this.parcelHighlight();
			}
			this.isLoaded = true;
		}
	},
	watch: {
		$route:function(toRoute, fromRoute){
			if (toRoute.query.addressId) this.$data.addressId = toRoute.query.addressId;
			if (toRoute.params.parcelId && toRoute.params.parcelId !== toRoute.params.parcelId){
				this.getParcelRec();
			}
		},
		parcel:function(){
			this.checkReady();
		},
		mapLoaded:function(){
			this.checkReady();
		}
	},
}

</script>

<style>
#unlock li{
	font-size:0.8rem;
	list-style-type:none;
	color:#212529;
}
#unlock blockquote p{
	font-size:16px;
}
#unlock p{
	font-size:0.8rem;
	color:#212529;
}
#unlock .back-btn{
	margin-left:-7px;
	margin-top:-1px;
}
#unlock .buy{
	bottom:0;
	left:0;
	right:0;
}
#unlock .blockquote-footer{
	font-size:0.8rem;
	line-height:20px;
}
#unlock .check-row-new{
	background-color:#FFF176;
	padding:0 2px;
}
#unlock .nav-link{
	cursor:pointer;
	color:#CCC;
}
#unlock .nav-link:hover{
	color:#EEE;
}
#unlock .package-option{
	background: #fff;
    border-radius: 42px;
    border:1px solid #CCC;
    padding:1px;
    font-size:22px;
}
#unlock .parcel-options i{
	cursor:pointer;
	color:#868e96;
}
#unlock .parcel-options i:hover{
	color:#FFFFFF;
}
#unlock .plan-option{
	text-align:center;
	background-color:#FAFAFA;
	padding:0.5rem 0;
	border-right:1px solid #EEEEEE;
	border-top:1px solid #EEEEEE;
	cursor:pointer;
}
#unlock .plan-option:hover{
	background-color:#FFF;
}
#unlock .plan-option.active{
	background-color:#B61D1D;
	color:#FFF;
	border:1px solid #B61D1D;
}
#unlock .plan-option h3{
	font-size:2rem;
	margin-bottom:0;
	position:relative;
}
#unlock .plan-option p{
	margin-bottom:0;
}
#unlock .plan-option.active p{
	color:#FFF;
}
#unlock .plan-option h4{
	font-size:1rem;
	margin-bottom:0;
}
#unlock .plan-selected{
	background-color:#FFF;
	border-bottom:2px solid #B61D1D;
	border-top:2px solid #B61D1D;
	color:#FFF;
	text-align:center;
	overflow:hidden;
}
#unlock .plan-selection{
	z-index:1030;
	overflow:hidden;
}
#unlock .close-btn{
	color:#6F6F6F;
	cursor:pointer;
	margin-top:2px;
}
#unlock .close-btn:hover{
	color:#4E4E4E;
}
#unlock .text-title{
	color:#6F6F6F;
}
#unlock .border-bottom-gray{
	border-bottom:1px solid #EEE;
}

#unlock .hover-gray-lt{
	cursor:pointer;
	background-color:#EFEFEF;
}
#unlock .hover-gray-lt:hover{
	background-color:#F5F5F5;
}

#unlock .mt-radio{
	margin-top:-3px;
}

#unlock .field-row{
	font-size:16px;
	line-height:28px;
}
</style>


// WEBPACK FOOTER //
// src/components/unlock/unlock.vue